import React from 'react';
import cx from 'classnames';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import { DirectionButton } from '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import { Switch } from '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const PageNavigationBar = ({
  prevButtonHref,
  prevButtonClick,
  title,
  subtitle,
  className,
  style,
  size = "lg",
  chartButton,
  collectButton,
  maxButton,
  settingsButton,
  switchButton,
  fairText,
  showLogo = true,
  animation = {
    "data-aos": "fade-up",
    "data-aos-delay": "200",
    "data-aos-delay-step": 0,
    "data-aos-duration": "1000"
  },
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ...props,
    className: cx(styles.box, className, {
      [styles[size]]: !!size
    }),
    style,
    ...animation
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.row }, size === "lg" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement("div", { className: styles.prev }, /* @__PURE__ */ React.createElement(
    DirectionButton,
    {
      href: prevButtonHref,
      onClick: prevButtonClick,
      size: "md",
      direction: "prev",
      buttonType: true,
      hideOnMobile: true,
      className: styles.prev__btn
    }
  ), /* @__PURE__ */ React.createElement("div", { className: styles.text }, /* @__PURE__ */ React.createElement("div", { className: styles.text__title }, title), /* @__PURE__ */ React.createElement("div", { className: styles.text__subtitle }, subtitle)))), showLogo && /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement("div", { className: styles.logo }, /* @__PURE__ */ React.createElement(Icon, { iconName: "HousebetsLogoIcon" })))), /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement("div", { className: styles.toolbar }, switchButton && /* @__PURE__ */ React.createElement(
    Switch,
    {
      label: switchButton.text || "Demo mode",
      size: "large-2",
      isChecked: switchButton.checked,
      onCheck: switchButton.onChange,
      theme: "grey-2",
      flow: "reverse",
      className: styles.switch
    }
  ), fairText && /* @__PURE__ */ React.createElement("span", { className: styles.fair }, fairText), maxButton && (maxButton.customButton || /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: maxButton?.onClick,
      className: cx(styles.button, {
        [styles.active]: maxButton.active
      }),
      type: "button",
      "aria-label": "open chart"
    },
    /* @__PURE__ */ React.createElement(Icon, { iconName: "MaxIcon" })
  )), collectButton && (collectButton.customButton || /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: collectButton?.onClick,
      className: cx(styles.button, {
        [styles.active]: collectButton.active
      }),
      type: "button",
      "aria-label": "open chart"
    },
    /* @__PURE__ */ React.createElement(
      Icon,
      {
        iconName: collectButton.active ? "FavoriteFill" : "Favorite"
      }
    )
  )), chartButton && (chartButton.customButton || /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: chartButton?.onClick,
      className: cx(styles.button, {
        [styles.active]: chartButton.active
      }),
      type: "button",
      "aria-label": "open chart"
    },
    /* @__PURE__ */ React.createElement(Icon, { iconName: "ChartIcon" })
  )), settingsButton && (settingsButton.customButton || /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: settingsButton?.onClick,
      className: cx(styles.button, {
        [styles.active]: settingsButton.active
      }),
      type: "button",
      "aria-label": "open chart"
    },
    /* @__PURE__ */ React.createElement(Icon, { iconName: "SettingsV3" })
  ))))))
);
PageNavigationBar.displayName = "PageNavigationBar";

export { PageNavigationBar };
//# sourceMappingURL=index.js.map
